import { selectAnnotationView } from "@/entities/annotation";
import { getAnnotationForm } from "../annotation-types/mappings/annotation-form-mapping";
import { useAppSelector } from "@/app/appStore";

export const AnnotationSidebar: React.FC = () => {
  const annotationView = useAppSelector(selectAnnotationView);
  const AnnotationForm = getAnnotationForm(annotationView);

  return <AnnotationForm />;
};
